/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface AnswerExtractionUsage
 */
export interface AnswerExtractionUsage {
    /**
     * 
     * @type {number}
     * @memberof AnswerExtractionUsage
     */
    inputTokenCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerExtractionUsage
     */
    outputTokenCount?: number;
    /**
     * 
     * @type {string}
     * @memberof AnswerExtractionUsage
     */
    modelName?: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerExtractionUsage
     */
    durationMs?: number;
}

/**
 * Check if a given object implements the AnswerExtractionUsage interface.
 */
export function instanceOfAnswerExtractionUsage(value: object): boolean {
    return true;
}

export function AnswerExtractionUsageFromJSON(json: any): AnswerExtractionUsage {
    return AnswerExtractionUsageFromJSONTyped(json, false);
}

export function AnswerExtractionUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerExtractionUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'inputTokenCount': json['inputTokenCount'] == null ? undefined : json['inputTokenCount'],
        'outputTokenCount': json['outputTokenCount'] == null ? undefined : json['outputTokenCount'],
        'modelName': json['modelName'] == null ? undefined : json['modelName'],
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
    };
}

export function AnswerExtractionUsageToJSON(value?: AnswerExtractionUsage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'inputTokenCount': value['inputTokenCount'],
        'outputTokenCount': value['outputTokenCount'],
        'modelName': value['modelName'],
        'durationMs': value['durationMs'],
    };
}

